import * as z from "zod";

export const enableAutoMerge = {
  name: "enableAutoMerge" as const,
  input: z.object({ groupIds: z.array(z.string()).min(1).max(500) }),
  output: z.object({ success: z.boolean() }),
};
